// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer___VRDe","calendarButtons":"ClockData_calendarButtons__2cC6R"};